import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import dateFormat from "dateformat";
import { BsArrowRight, BsCalendarMinusFill, BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import Swal from 'sweetalert2'
import AuthContext from "../../../auth/authContext";
import { TODIS_COMMENT } from "../../../.config/form/network_performance";
import style from "../Modal.module.scss";
import "../../../pages/DataCollection/style.css";
import { TODIS_FORM_DSC } from "../../Forms";
import { RequestService } from "../../../HttpService/RequestService";
import { Form, Formik } from "formik";
import { propTypes } from "react-bootstrap/esm/Image";

const MODAL_CONFIRM = ({onSubmit, dataForm, ...restProps}) => {

    return (
        <Modal
            {...restProps}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={style.todisModalContainer}
            dialogClassName={style.sizeModal50}
            centered
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    <BsCalendarMinusFill className="me-3" />Save Form
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid className="todis-form-wrapper p-3" style={{height: "100%"}}>
                    <Row>
                        <Formik
                            initialValues={{comment: ""}}
                            validationSchema={TODIS_COMMENT}
                            onSubmit={(values) => onSubmit(values.comment, dataForm)}>
                            {({ errors, touched, values }) => (
                                <Form className="todis-form-content p-0">
                                    <Container>
                                        <Row>
                                            <Col lg={12}>
                                                <TODIS_FORM_DSC id="comment" label="COMMENT" name="comment" text=""/>
                                                {errors.comment && touched.comment ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.comment}</div>) : null}
                                            </Col>
                                            <div className="todis-action-form">
                                                <Button variant="outline-danger" onClick={() => restProps.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                                <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{margin: "0.5rem"}}>SUBMIT <BsArrowRight size={20} /></Button>
                                            </div>
                                        </Row>
                                    </Container>
                                </Form>
                            )}
                        </Formik>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    )
}

export { MODAL_CONFIRM };